// ============================================================
// UI Store (Zustand)
// ============================================================
// Transient UI state: mobile drawer, page metadata, modals.

import { create } from 'zustand';

const useUiStore = create((set) => ({
  // ── State ────────────────────────────────────
  mobileDrawerOpen: false,
  pageTitle: '',
  breadcrumbs: [],
  activeModal: null,
  modalData: null,

  // ── Actions ──────────────────────────────────
  setMobileDrawerOpen: (open) => set({ mobileDrawerOpen: open }),
  toggleMobileDrawer: () =>
    set((state) => ({ mobileDrawerOpen: !state.mobileDrawerOpen })),

  setPageMeta: ({ title, breadcrumbs = [] }) =>
    set({ pageTitle: title, breadcrumbs }),

  openModal: (modalId, data = null) =>
    set({ activeModal: modalId, modalData: data }),

  closeModal: () =>
    set({ activeModal: null, modalData: null }),
}));

export default useUiStore;
